/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    path: '/login',
    name: 'Login',
    view: 'auth/Login',
    meta: {
      requiresVisitor: true
    }
  },
  {
    path: '/logout',
    name: 'logout',
    view: 'auth/Logout'
  },
  {
    path: '/main',
    name: 'Main',
    view: 'Main',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'opportunity/new',
    name: 'CreateOpportunity',
    view: 'CreateOpportunity',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'contact/new',
    name: 'CreateContact',
    view: 'CreateContact',
    meta: {
      requiresAuth: true
    }
  }  

]
